var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20 6 9 17l-5-5"}));
}

Check.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"lucide lucide-check-icon lucide-check"};

module.exports = Check;

Check.default = Check;
